export default "__VITE_ASSET__868e8d68__"